import React, {Component} from 'react';
import {connect} from 'react-redux';
import {getTranslate, getActiveLanguage} from 'react-localize-redux';
import _ from 'lodash';

import * as actions from '../../../../actions';

import {Maybe} from '../../../../utils/logging';
import {setLanguageIndex, checkboxLog, selectLog, extractKTIEFE, generateSummary} from '../../../../utils/helpers';

class KrwSummary extends Component {

    calculateSize(type) {
        const getValue = (field) => {
            return Maybe.of(field)
                .map((field) => {
                    return parseFloat(field.CurrentValue);
                })._value || 0;
        }
        if (type === 'lange') {
            return (parseInt(getValue(this.props.krw.W_LAENGE)));
        }
        if (type === 'breite') {
            return (parseInt(getValue(this.props.krw.W_BREITE)));
        }
    }

    render() {
        const details = [];
        const getLanguageIndex = setLanguageIndex(this.props.currentLanguage);

        details.push(`${this.props.translate(`KRW.stepOne.menu.body.2`)} ${this.calculateSize('lange')} mm x ${this.calculateSize('breite')} mm`);

        const checkboxContent = [];
        // Set FA
        Maybe.of(selectLog(this.props, 'krw', 'FA',`${setLanguageIndex(this.props.currentLanguage)}`)._value)
            .map((value) => {
                let farbe = this.props.translate(`KRW.stepSeven.menu.title2`);
                details.push(`${farbe}: ${value} (FA ${this.props.krw.FA.CurrentValue})`);
                return true;
            });

        // Set OV
        Maybe.of(checkboxLog(this.props, 'krw', 'OV', 'stepSeven')._value)
            .map((value) => {
                checkboxContent.push(value);
                return true;
            });

        details.push(checkboxContent.join(', '));

        const SIK = (field) => {
            return Maybe.of(field)
                .map((field) => {
                    return parseInt(field.CurrentValue);
                })
                .map((field_value) => {
                    details.push(`${this.props.translate(`KRW.stepTwo.menu.body.1`)} (SIK ${this.props.krw.SIK.CurrentValue})`);
                })
        };
        SIK(this.props.krw.SIK);
        
        const SICHTKANTE = (field) => {
            return Maybe.of(this.props.krw[`${field}_activator`])
                .map((field) => {
                    return field.CurrentValue;
                })
                .map((field_value) => {
                    if(field_value === '0') {
                        Maybe.of(this.props.krw[`${field}_switch`])
                            .map((zswitch) => {
                                return zswitch.CurrentValue;
                            })
                            .map((zswitch_value) => {
                                if(zswitch_value !== '0') {
                                    details.push(this.props.translate(`KRW.stepTwo.summary.${field}.${zswitch_value}`));
                                }
                            });
                    }
                })
        };

        ['SK23', 'SK45', 'SK67', 'SK81'].forEach((field) => {
            SICHTKANTE(field);
        });

        const SOCKET = (field) => {
            let socket, choice, posX, posY;
            return Maybe.of(this.props.krw[field])
                .map((field) => {
                    return field.CurrentValue;
                })
                .map((field_value) => {
                    if(field_value !== '0' && field_value !== '00') {
                        socket = this.props.translate(`KRW.stepThree.menu.body.${field}`);
                        choice = this.props.krw[field].Values.Value.find(((el) => {return parseInt(el.Code) === parseInt(field_value)})).Description[`${setLanguageIndex(this.props.currentLanguage)}`];
                        posX = `${this.props.krw[field.concat('X')].CurrentValue} mm`;
                        posY = `${this.props.krw[field.concat('Y')].CurrentValue} mm`;
                        details.push(`${socket}: ${choice} -`);
                        details.push(` · Position X: ${posX}`);
                        details.push(` · Position Y: ${posY}`);
                    }
                })
        };

        ['ST1', 'ST2', 'ST3', 'ST4', 'ST5'].forEach((field) => {
            SOCKET(field);
        });

        const CUTOUT = (field) => {
            let cutout, measure, posX, posY;
            return Maybe.of(this.props.krw[field])
                .map((field) => {
                    return field.CurrentValue;
                })
                .map((field_value) => {
                    if(field_value !== '0' && field_value !== '00') {
                        cutout = this.props.translate(`KRW.stepFour.menu.summary.${field}`);
                        measure = `${this.props.krw[field.concat('X')].CurrentValue} mm x ${this.props.krw[field.concat('Y')].CurrentValue} mm`;
                        posX = `${this.props.krw[field.concat('PX')].CurrentValue} mm`;
                        posY = `${this.props.krw[field.concat('PY')].CurrentValue} mm`;
                        details.push(`${cutout}: ${measure}`);
                        details.push(` · Position X: ${posX}`);
                        details.push(` · Position Y: ${posY}`);
                    }
                })
        };

        ['AS1', 'AS2', 'AS3', 'AS4', 'AS5'].forEach((field) => {
            CUTOUT(field);
        });

        const CUTOUTROUND = (field) => {
            let cutout, measure, posX, posY;
            return Maybe.of(this.props.krw[field])
                .map((field) => {
                    return field.CurrentValue;
                })
                .map((field_value) => {
                    if(field_value !== '0' && field_value !== '00') {
                        cutout = this.props.translate(`KRW.stepFive.menu.summary.${field}`);
                        measure = `D ${this.props.krw[field.concat('D')].CurrentValue} mm`;
                        posX = `${this.props.krw[field.concat('PX')].CurrentValue} mm`;
                        posY = `${this.props.krw[field.concat('PY')].CurrentValue} mm`;
                        details.push(`${cutout}: ${measure}`);
                        details.push(` · Position X: ${posX}`);
                        details.push(` · Position Y: ${posY}`);
                    }
                })
        };

        ['ASR1', 'ASR2', 'ASR3', 'ASR4', 'ASR5'].forEach((field) => {
            CUTOUTROUND(field);
        });

        const SIDEFLANGE = (field) => {
            let sideflange, measure;
            return Maybe.of(this.props.krw[field])
                .map((field) => {
                    return field.CurrentValue;
                })
                .map((field_value) => {
                    if(field_value !== '0' && field_value !== '00') {
                        sideflange = this.props.translate(`KRW.stepSix.menu.body.${field}`);
                        measure = this.props.krw[field.replace(/GK/g, "GKM")].CurrentValue;
                        details.push(`${sideflange}: ${measure} mm`);
                    }
                })
        };

        ['GK45', 'GK81'].forEach((field) => {
            SIDEFLANGE(field);
        });

        return details.map((item, index) => {
            return (
                <div key={index}>{item}</div>
            )
        })
    }

}


function mapStateToProps({krw, locale}) {
    return {
        translate:      getTranslate(locale),
        currentLanguage: getActiveLanguage(locale).code,
        krw,
    }
}

export default connect(mapStateToProps, actions)(KrwSummary);



// WEBPACK FOOTER //
// ./src/components/download/additionalInfo/summary/KrwSummary.js